"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Input = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _withSpacing = _interopRequireWildcard(require("../withSpacing"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "text": "tcl__Input-b9c57394",
  "small": "tcl__Input-1be89fb6",
  "medium": "tcl__Input-c6bf2c95",
  "isInvalid": "tcl__Input-0eb86cf4",
  "checkbox": "tcl__Input-42838846",
  "radio": "tcl__Input-0784f0e7",
  "wrapper": "tcl__Input-67b59825",
  "prefix": "tcl__Input-18e88275",
  "left": "tcl__Input-d168df6f",
  "right": "tcl__Input-0c703d5b",
  "hasPrefix": "tcl__Input-a1a84bff"
};

function isSet(prop) {
  return typeof prop !== 'undefined' && prop !== null;
}
/**
 * Core Input component.
 */


class Input extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onClick", e => {
      // checked='indeterminate' controlled state
      if (this.props.checked === 'indeterminate') {
        e.target.indeterminate = true;
      }

      this.props.onClick(e);
    });

    _defineProperty(this, "setIndeterminate", () => {
      // set the indeterminate state since react does not support it as a native prop
      const {
        type,
        checked,
        defaultChecked
      } = this.props;
      if (type !== 'checkbox') return;
      this.input.indeterminate = checked === 'indeterminate' || defaultChecked === 'indeterminate';
    });
  }

  componentDidMount() {
    this.setIndeterminate();
  }

  componentDidUpdate() {
    this.setIndeterminate();
  }

  render() {
    const {
      type,
      className,
      inputRef,
      isValid,
      checked,
      defaultChecked,
      prefix,
      prefixIcon,
      prefixLocation,
      size,
      ...props
    } = this.props;
    const hasPrefix = Boolean(prefix) || Boolean(prefixIcon);
    const inputClass = styles[['checkbox', 'radio'].includes(type) ? type : 'text'];
    const iconSizes = {
      small: 18,
      medium: 24
    };
    const extraProps = {};
    if (isSet(checked)) extraProps.checked = checked === true;
    if (isSet(defaultChecked)) extraProps.defaultChecked = defaultChecked === true;

    const input = /*#__PURE__*/_react.default.createElement("input", _extends({
      ref: el => {
        this.input = el;
        inputRef(el);
      },
      type: type,
      className: (0, _classnames.default)(className, inputClass, styles[size], styles[prefixLocation], {
        [styles.isInvalid]: !isValid,
        [styles.hasPrefix]: hasPrefix
      })
    }, props, {
      onClick: this.onClick
    }, extraProps));

    return hasPrefix ? /*#__PURE__*/_react.default.createElement("div", {
      className: styles.wrapper
    }, hasPrefix && /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(styles.prefix, styles[size], styles[prefixLocation], {
        [styles.isInvalid]: !isValid
      })
    }, prefix || /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: prefixIcon,
      size: iconSizes[size]
    })), input) : input;
  }

}

exports.Input = Input;
Input.displayName = "Input";
Input.propTypes = { ..._withSpacing.propTypes,

  /**
   * Any additional css classes.
   */
  className: _propTypes.default.string,

  /**
   * Indicates that the input's content is not valid.
   */
  isValid: _propTypes.default.bool,

  /**
   * Controlled value for checkbox. The "indeterminate" value represents a state when related
   * items are not all checked (e.g. nested checkboxes or select all items in page).
   */
  checked: _propTypes.default.oneOf([true, false, 'indeterminate']),

  /**
   * Uncontrolled value for checkbox.
   */
  defaultChecked: _propTypes.default.oneOf([true, false, 'indeterminate']),

  /**
   * Function called when input is clicked.
   */
  onClick: _propTypes.default.func,

  /**
   * Type of input. Can be any of the available HTML types.
   */
  type: _propTypes.default.oneOf(['button', 'checkbox', 'color', 'date', 'datetime-local', 'email', 'file', 'hidden', 'image', 'month', 'number', 'password', 'radio', 'range', 'reset', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week']),

  /**
   * Function called with reference to native `<input>` element.
   */
  inputRef: _propTypes.default.func,

  /**
   * Letter prefix, displayed in a box before the editable content.
   */
  prefix: _propTypes.default.string,

  /**
   * Icon prefix, displayed in a box before the editable content.
   */
  prefixIcon: _propTypes.default.string,

  /**
   * Prefix location, the prefix can be displayed either on the left or right side of the input.
   */
  prefixLocation: _propTypes.default.oneOf(['left', 'right']),

  /**
   * The size of the input (text input only).
   */
  size: _propTypes.default.oneOf(['small', 'medium'])
};
Input.defaultProps = {
  type: 'text',
  isValid: true,
  onClick: _noop.default,
  inputRef: _noop.default,
  className: '',
  checked: undefined,
  defaultChecked: undefined,
  prefix: undefined,
  prefixIcon: undefined,
  prefixLocation: 'left',
  size: 'small'
};

var _default = (0, _withSpacing.default)(Input);

exports.default = _default;